
const datetimeFormatter = (seconds?: boolean) => new Intl.DateTimeFormat('hr-HR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: seconds ? '2-digit' : undefined,
});

export const formatDateTime = (datetime: string | Date, seconds?: boolean) => {
    if (typeof datetime === 'string') {
        datetime = new Date(datetime);
    }

    return datetimeFormatter(seconds).format(datetime);
};
